"use client";

import { SessionProvider } from "next-auth/react";
import { ThemeProvider } from "next-themes";
import { ThemeSync } from "@/components/account/theme-sync";

export function Providers({ children }: { children: React.ReactNode }) {
  // Release A: the shell gains a light/system/dark toggle (brand strip). The app
  // was previously hardcoded dark (`<html className="dark">`); `defaultTheme="dark"`
  // preserves that as the default. `attribute="class"` toggles the `.dark` class
  // globals.css already keys on; `enableSystem` resolves `system` via
  // prefers-color-scheme at render time (no persisted resolved boolean).
  //
  // 2.2 §12.14: next-themes' localStorage is now the FIRST-PAINT device cache only;
  // ThemeSync pulls the SERVER-stored per-user theme once the session resolves and
  // applies it, so the server value is the source of truth across devices.
  return (
    <SessionProvider>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        disableTransitionOnChange
      >
        <ThemeSync />
        {children}
      </ThemeProvider>
    </SessionProvider>
  );
}
